import React from 'react'
import PendingVerificationTable from './PendingVerificationTable';
import { Box } from '@mui/material';

const PendingVerificationData = () => {
    return (
        <Box bgcolor={"#F3F3F3"} height={"100%"}>
            <PendingVerificationTable />
        </Box>
    )
}

export default PendingVerificationData;
